var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex gap-2 align-items-center flex-wrap"},_vm._l((_vm.featuredTags),function(tag){return _c('featured-vendor-tag',{key:tag.id,class:_vm.tagClass,attrs:{"tag":tag}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }